// 家具行业
import { getPartitioningChild } from '@/utils/api'

export default {
  state: {
    // 家具细分市场列表
    furnitureMarketList: [],
  },
  getters: {},
  mutations: {
    // 设置家具细分市场列表
    setFurnitureMarketList(state, data) {
      state.furnitureMarketList = [...data]
    },
  },
  actions: {
    // 获取家具细分市场列表
    async getFurnitureMarketList({ commit }) {
      let [err, res] = await getPartitioningChild(6)
      if (err) return
      // 保存车型列表
      commit('setFurnitureMarketList', res)
    },
  }
}
